/** Returns true if the string provided is a relative link */
export function isRelative(href: string): boolean {
  return /^\//.test(href)
}

/** Returns true if the string provided is a URL hash fragment */
export function isHashLink(href: string): boolean {
  return /^#/.test(href)
}
